import { Amplify } from 'aws-amplify';
import config from 'config';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { REST_API_CONF } from 'utils/lib/api_config';
import { sessionStorage } from 'aws-amplify/utils';
let appInitilizedOnce = false;
let isInitializing = false;
let initializationPromise = null;



/**
 * Ensures Amplify is configured before proceeding.
 * @returns {Promise<void>}
 */
export const ensureAmplifyConfigured = async () => {
    try {
        if (isInitializing && initializationPromise) {
            await initializationPromise;
            return;
        }
        const aws_config = Amplify.getConfig();
        if (!aws_config || 
            typeof aws_config !== 'object' || 
            Object.keys(aws_config).length === 0 ||
            !aws_config.Auth || 
            !aws_config.Auth.Cognito || 
            !aws_config.API || 
            !aws_config.API.REST) {
            
            if (isInitializing) {
                if (initializationPromise) {
                    await initializationPromise;
                }
                return;
            }
            
            isInitializing = true;
            initializationPromise = new Promise((resolve, reject) => {
                try {
                    initApp();
                    const verifyConfig = Amplify.getConfig();
                    if (!verifyConfig || !verifyConfig.Auth || !verifyConfig.API) {
                        reject(new Error('Failed to initialize Amplify configuration'));
                    } else {
                        resolve();
                    }
                } catch (error) {
                    reject(error);
                } finally {
                    isInitializing = false;
                }
            });
            
            await initializationPromise;
        }
    } catch (error) {
        console.error('[ensureAmplifyConfigured] Error ensuring Amplify configuration:', error);
        isInitializing = false;
        throw error;
    }
};


export const initApp = () => {
    if (appInitilizedOnce) {
        const aws_config = Amplify.getConfig();
        if (aws_config && aws_config.Auth && aws_config.Auth.Cognito && aws_config.API && aws_config.API.REST) {
            return;
        }
    }
    Amplify.configure({
        Auth: {
            Cognito: {
                mandatorySignIn: true,
                region: config.cognito.REGION,
                userPoolId: config.cognito.USER_POOL_ID,
                identityPoolId: config.cognito.IDENTITY_POOL_ID,
                userPoolClientId: config.cognito.APP_CLIENT_ID,
                loginWith: {
                    username: true,
                },
                clockDriftTolerance: 900000,
            },
        },
        API: {
            REST: REST_API_CONF,
        },
    });
    cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
    appInitilizedOnce = true;
}